import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const baseButtonClasses =
  'flex h-fit w-fit justify-center gap-md rounded-full hover:bg-background-primary-hover hover:text-text-inverse active:bg-background-primary-active';

export const buttonSizeClasses = {
  lg: 'px-3xl py-[14px] t-label-lg',
  md: 'px-2xl py-lg t-label-md',
  sm: 'px-xl py-[10px] t-label-sm',
  xs: 'px-xl py-[6px] t-label-sm'
};

export const primaryButtonClasses = 'bg-background-primary text-text-inverse';

export const secondaryButtonClasses =
  'text-text-primary bg-transparent border-[1.5px] hover:border-transparent active:border-transparent border-border-primary';

export type ButtonProps = ElementWithProps<
  { size?: 'lg' | 'md' | 'sm' | 'xs' },
  HTMLButtonElement
>;

export const BaseButton = createComponent<ButtonProps>(
  'button',
  ({ size = 'md' }) => ({
    className: cx(baseButtonClasses, buttonSizeClasses[size])
  })
);

export const Button = createComponent<ButtonProps>(BaseButton, {
  className: primaryButtonClasses
});
